<template>
  <div>
    <ts-loading-banner :loading="loading">
      <form class="form-horizontal mt-3">
        <div class="row">
          <div class="col-md-7">
            <fieldset>
              <legend class="text-black">
                {{
                  $t(
                    'school.academic.operation.profile_mgt.studentProfile.bankAccountInfo'
                  )
                }}
              </legend>
              <div class="row">
                <div class="col-md-8">
                  <!-- begin widget-list -->
                  <div class="widget-list rounded mb-4">
                    <!-- begin widget-list-item -->
                    <div class="widget-list-item" v-for="(bank, index) in model.banks" :key="index">
                      <div class="widget-list-content">
                        <h2 class="widget-list-title ts-font-bold text-success">
                          {{ getBank(bank.bank_id).bank_name }}
                        </h2>
                        <table width="100%" class="table table-sm table-bordered align-middle">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Account Number</th>
                              <th>Account Name</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(acc, i) in getBank(bank.bank_id)
                              .bank_accounts" :key="i">
                              <td>
                                <input type="radio" v-model="bank.bank_accounts" :value="[
                                  {
                                    account_id: acc.account_id
                                  }
                                ]" />
                              </td>
                              <td>
                                {{
                                  getAccount(acc.bank_id, acc.account_id)
                                    .account_number
                                }}
                              </td>
                              <td>
                                {{
                                  getAccount(acc.bank_id, acc.account_id)
                                    .account_name
                                }}
                              </td>
                              <td>
                                {{
                                  getAccount(acc.bank_id, acc.account_id)
                                    .remarks
                                }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="widget-list-action">
                        <div class="custom-control custom-switch" v-tooltip="'Default'"
                          v-if="bank.bank_accounts.length > 0">
                          <input v-model="bank.is_default" @input="
                            event => setAsDefaultBank(bank.bank_id, event)
                          " type="checkbox" class="custom-control-input" :id="`customSwitchBank-${bank.bank_id}`" />
                          <label class="custom-control-label" :for="`customSwitchBank-${bank.bank_id}`"></label>
                        </div>
                      </div>
                    </div>
                    <!-- end widget-list-item -->
                  </div>
                  <!-- end widget-list -->
                  <div v-if="errors.has('banks')" class="text-danger">
                    {{ errors.first('banks') }}
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="col-md-3"></div>
        </div>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'bank-account',
  props: ['value', 'validate', 'clear'],
  data() {
    return {
      model: {},
      loading: false,
      errors: new Errors()
    }
  },
  created() {
    this.fetchBank()
  },
  computed: {
    ...mapState('studentProfile', ['bankProfiles', 'edit_data'])
  },
  methods: {
    ...mapActions('studentProfile', ['formViewModel']),
    ...mapMutations('studentProfile', ['SET_BANK_PROFILES']),
    fetchBank() {
      this.loading = true
      this.formViewModel({
        fnName: 'bank'
      })
        .then(response => {
          this.model = this.value
          this.loading = false
          this.SET_BANK_PROFILES(response.data.bank)
          this.model.banks = response.data.bank.map(b => ({
            bank_id: b.bank_id,
            is_default: false,
            bank_accounts: []
          }))
          this.setEditData()
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBank(bank_id) {
      return this.bankProfiles
        .filter(b => b.bank_id == bank_id)
        .reduce((init, item) => (init = item), null)
    },
    getAccount(bank_id, account_id) {
      return this.bankProfiles
        .filter(c => c.bank_id == bank_id)
        .flatMap(el =>
          el.bank_accounts.filter(item => item.account_id == account_id)
        )
        .reduce((init, item) => (init = item), 0)
    },
    setAsDefaultBank(bankId, event) {
      this.model.banks
        .filter(b => b.bank_id != bankId)
        .forEach(bank => {
          this.$set(bank, 'is_default', false)
        })

      this.model.banks
        .filter(b => b.bank_id == bankId)
        .forEach(bank => {
          this.$set(bank, 'is_default', event.target.checked)
        })
      this.$forceUpdate()
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.model.student_id = this.edit_data.student_id
        this.model.banks = this.model.banks.map(b => ({
          bank_id: b.bank_id,
          is_default: this.getDefaultBank(b.bank_id),
          bank_accounts: this.edit_data.bank_accounts
            .filter(acc => acc.bank_id == b.bank_id)
            .map(acc => ({
              account_id: acc.account_id
            }))
        }))
      }
    },
    getDefaultBank(bank_id) {
      return this.edit_data.bank_accounts
        .filter(b => b.bank_id == bank_id)
        .reduce((init, item) => (init = item.is_default), null)
    }
  },
  watch: {
    validate: {
      handler() {
        this.errors = new Errors(this.validate.errors)
      },
      deep: true
    },
    clear: function (value) {
      if (value == true) {
        this.model = this.value
      }
    }
  }
}
</script>
<style lang="css" scoped>
#branch-group {
  max-height: 360px;
  overflow-y: scroll;
}
</style>
